<template>
<v-toolbar flat>
  <div class="text-center">

    <v-btn fab small v-shortkey="['insert']" @shortkey="add()" :to="url" class="ma-2 white--text" color="success" v-if="formStatus === 'view'">
      <v-icon dark>
        mdi-plus
      </v-icon>
    </v-btn>

    <v-btn fab small v-shortkey="['esc']" @shortkey="back()" to="/" class="ma-2 white--text" color="info">
      <v-icon dark>
        mdi-logout-variant
      </v-icon>
    </v-btn>

  </div>
</v-toolbar>
</template>

<script>
//
export default {
  name: 'ListButtons',
  props: ['formStatus'],
  data: () => ({
    url: null
  }),
  async created() {
    this.url = `/${this.$store.getters.pageInfo.route}/add`
  },
  methods: {
    add() {
      this.$router.push(this.url)
    },
    back() {
      if (this.formStatus === 'view') {
        this.$router.push(`/`)
      } else {
        this.$emit('back')
      }
    }
  },
}
</script>
